import {
  login,
  logout,
  getUserInfo
} from '@/api/api'

import {
  Message
} from 'element-ui'

import router, {
  resetRouter
} from '@/router'

const state = {
  rememberLogin: localStorage.getItem('rememberLogin') ? localStorage.getItem('rememberLogin') : '',
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  isLogin: localStorage.getItem('isLogin') ? localStorage.getItem('isLogin') : '',
  productQuantity: localStorage.getItem('productQuantity') ? localStorage.getItem('productQuantity') : 0,
  token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
}

const actions = {
  login({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      console.log(params, 'params')
      login(params).then(res => {
        commit('SET_LOGIN', 1)
        console.log(res, 'res')
        resolve(res)
      }).catch(err => {
        commit('SET_LOGIN', '')
        reject(err)
      })
    })
  },

  //获取用户信息
  getUserInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then((res) => {
        commit('SET_USER_INFO', res.data)
        resolve(res)
      }).catch(err => {
        commit('SET_USER_INFO', {})
        reject(err);
      })
    })
  },

  // 登出
  logout({
    commit
  }) {
    return new Promise((resolve, reject) => {
      logout().then((res) => {
        localStorage.removeItem('userInfo')
        localStorage.removeItem('isLogin')
        localStorage.removeItem('token')
        state.token = ''
        commit('SET_LOGIN', '')
        commit('SET_USER_INFO', {})
        Message({
          message: '退出登录成功',
          type: 'success'
        });
        setTimeout(() => {
          router.push({
            path: '/login'
          })
          resetRouter()
        }, 500)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }
}
const mutations = {
  // 存用户信息
  SET_USER_INFO: (state, userInfo) => {
    console.log(state, userInfo, 'SET_USER_INFO')
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },

  // 登录状态
  SET_LOGIN: (state, isLogin) => {
    console.log(state, isLogin, 'SET_LOGIN')
    state.isLogin = isLogin;
    localStorage.setItem('isLogin', isLogin)
  },

  // 记住登录状态
  SET_REMEMBER_LOGIN: (state, rememberLogin) => {
    console.log(state, rememberLogin, 'SET_REMEMBER_LOGIN')
    state.rememberLogin = rememberLogin;
    localStorage.setItem('rememberLogin', rememberLogin)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js